module.exports = __webpack_public_path__ + "assets/img/extreme.240feb49.png";